import React from "react";
import Text from "../../../../shared/components/Text";
import { notValidIBANReasons } from "../../DeclaredIncome/shared/constants/notValidIBANReasons";

export const getInformationTextByNonValidAction = (nonValidAction) => {
  switch (nonValidAction) {
    case notValidIBANReasons.IBANNotInSepaList:
      return <Text tId={"IBAN_NOT_IN_SEPA_LIST_USAGE_REMINDER"} />;
    case notValidIBANReasons.notValidIBANFormat:
      return <Text tId={"INVALID_IBAN_USAGE_REMINDER"} />;
    default:
      break;
  }
};
